import _ from 'underscore';
import { useRef } from 'react';

export function useDeepMemo(value) {
  const ref = useRef();

  if (!_.isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
